import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

interface Props {
  onChange?: (value: string) => void;
}

const ReCAPTCHAInput: React.FC<Props> = ({onChange}) => (
  <ReCAPTCHA sitekey={process.env.RECAPTCHA_TOKEN} onChange={onChange} />
);

export default ReCAPTCHAInput;
